<template>
  <div class="amap-wrapper">
    <div ref="mapContainer" class="map-container"></div>

    <div class="info-card">
      <div class="card-content">
        <div>姓名: {{ options.name }}</div>
        <div>类型: {{ options.type == 1 ? "SOS报警" : options.type == 2 ? "跌倒报警" : ""}}</div>
        <div>时间: {{ options.date }}</div>
        <div>地点: {{ options.datail }}</div>
      </div>
    </div>

    <slot :map="map" :AMap="AMap"></slot>
  </div>
</template>

<script>
export default {
  name: "AMapLoader",
  props: {
    center: {
      type: Array,
      default: () => [],
    },
    options: {
      type: Object,
      default: () => ({
        key: "", // 替换为实际Key
        version: "2.0",
        plugins: [], // 需要加载的插件
        mapOptions: {
          // 地图初始化参数
          zoom: 15,
          center: [],
        },
      }),
    },
  },
  data() {
    return {
      map: null,
      AMap: null,
    };
  },
  mounted() {
    this.initMap();
  },
  beforeDestroy() {
    this.destroyMap();
  },
  methods: {
    initMap() {
      console.log("key", this.options.key)
      if (window.AMapLoader) {
        window.AMapLoader.load({
          key: this.options.key,
          version: this.options.version,
          plugins: this.options.plugins,
        })
          .then((AMap) => {
            this.AMap = AMap;
            this.initMapInstance(AMap);
          })
          .catch((e) => {
            console.error("地图加载失败:", e);
            this.$emit("error", e);
          });
      } else {
        console.error("AMapLoader未定义，请检查脚本加载");
      }
    },

    initMapInstance(AMap) {
      this.map = new AMap.Map(this.$refs.mapContainer, this.options.mapOptions);
      this.$emit("init", { map: this.map, AMap });

      // 自动适应容器大小变化
      window.addEventListener("resize", this.handleResize);
      this.handleResize();
    },

    handleResize() {
      if (this.map) {
        this.$nextTick(() => {
          this.map.resize();
        });
      }
    },

    destroyMap() {
      window.removeEventListener("resize", this.handleResize);
      if (this.map) {
        this.map.destroy();
        this.map = null;
        this.AMap = null;
      }
    },
  },
};
</script>

<style scoped>
.amap-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
}

.map-container {
  width: 100%;
  height: 100%;
}

.info-card {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 1000; /* 确保卡片在地图之上 */
  background: white;
  padding: 8px 12px;
  border-radius: 4px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
  font-size: 14px;
}

.card-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
</style>
